<template>
  <div class="text-center">
    <img
      src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/cargador-logo-sistema-de-admision.png"
      class="img-fluid mt-1 mb-2 mt-lg-2"
      alt
    />
  </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/generales/modales/Cargando.vue